import React from "react";
import StaffCard from "../../Staff/partials/StaffProfileCard";
import TimeAgo from "react-timeago";

const AdminList = ({ items, onRevoke, onCancelRevoke }) => {
	const list = items || [];
	return (
		<div className="row">
			{list.map((item, idx) => (
				<div key={idx} className="col-md-4 col-sm-6 col-xs-12">
					<div className="card">
						<div className="card-body">
							<h5 className="text-muted">Super Admin</h5>
							<StaffCard item={item.staff} />
						</div>
						<div className="card-body">
							<h5 className="text-muted">Granted By</h5>
							<StaffCard item={item.grantedBy} />
						</div>
						<div className="card-body">
							<h5 className="text-muted">Duration:</h5>
							<TimeAgo date={item.created_at} />
						</div>
						<div className="card-footer">
							<div className="profile-userbuttons">
								{item.revoked ? (
									<button
										type="button"
										onClick={() => onCancelRevoke(item)}
										className="mdl-button mdl-button--raised mdl-js-ripple-effect m-b-10 btn-success btn-circle"
									>
										Grant Rights <i className="material-icons">check</i>
									</button>
								) : (
									<button
										type="button"
										onClick={() => onRevoke(item)}
										className="mdl-button mdl-button--raised mdl-js-ripple-effect m-b-10 btn-danger btn-circle"
									>
										<i className="material-icons">cancel</i> Revoke Right
									</button>
								)}
							</div>
						</div>
					</div>
				</div>
			))}
			{list.length < 1 && (
				<div
					className="col-md-12 text-center fade-in"
					style={{ paddingTop: "4em" }}
				>
					<i
						style={{
							fontSize: "64px"
						}}
						className="material-icons text-muted"
					>
						info
					</i>
					<h4>No Super Admin is Added yet!</h4>
				</div>
			)}
		</div>
	);
};

export default AdminList;
